import { render } from "./IPP.vue?vue&type=template&id=41b5d5a0"
import script from "./IPP.vue?vue&type=script&lang=js"
export * from "./IPP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__